<template>
  <v-card class="mb-4">
    <v-toolbar dense>
      <v-toolbar-title>
        <!-- <v-btn icon>
          <v-icon v-if="showTabs">expand_more</v-icon>
          <v-icon v-else>chevron_right</v-icon>
        </v-btn> -->
        Addresses
      </v-toolbar-title>
      <v-spacer />
      <edit-resource-button
        resource-label="Address"
        resource-name="addresses"
        resource-id-field="addressid"
        :resource="{ personid: personId, countryid: 1, addresstypeid: 2 }"
        :filter="{ where: { personid: personId } }"
        :create-new="true"
        @save="refreshResources()"
        :disabled="!currentUserCan('editAddresses')"
      >
        <template v-slot:default="editProps">
          <address-form :address="editProps.item"></address-form>
        </template>
      </edit-resource-button>
      <v-btn icon @click="refreshResources()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-toolbar>
    <v-card-text>
      <!-- <v-btn
        @click="showTabs = true"
        v-if="!showTabs"
      >Click to view addresses...</v-btn> -->

      <v-progress-linear indeterminate :active="loading" />

      <div v-if="errors.length > 0">
        <v-alert v-for="message in errors" :key="message" type="error">
          {{ message }}
        </v-alert>
      </div>

      <v-tabs v-model="activeTab">
        <v-tab>Work</v-tab>
        <v-tab-item>
          <v-container>
            <work-address-list :person-id="personId" />
          </v-container>
        </v-tab-item>

        <v-tab
          v-for="address in activeAddresses"
          :key="address.addressid"
          ripple
          :value="address.addressid"
        >
          <span
            ><strong>{{ lookup("AddressType", address.addresstypeid) }}</strong>
            <br />
            <em>{{ address.employer || address.address1 }}</em></span
          >
        </v-tab>
        <v-tab-item v-for="address in activeAddresses" :key="address.addressid">
          <v-card flat color="grey-lighter">
            <v-card-text>
              <div class="address">
                <p class="nl2br">{{ address.displayAddress }}</p>
                <!-- <p>{{ address.employer }}</p>
                <p>{{ address.address1 }}</p>
                <p>{{ address.address2 }}</p>
                <p>{{ address.address3 }}</p>
                <p>{{ address.address4 }}</p>
                <p>{{ address.address5 }}</p>
                <p>{{ address.city }} {{ address.postcode }}</p>
                <p>{{ address.region }}</p>
                <p>{{ address.country.name }}</p> -->
                <br />
                <p>
                  <em>
                    Created: {{ address.createdate | formatDate }}
                    {{ address.createdby ? `by ${address.createdby}` : "" }}
                  </em>
                </p>
                <p>
                  <em>
                    Updated: {{ address.updatedate | formatDate }}
                    {{ address.updatedby ? `by ${address.updatedby}` : "" }}
                  </em>
                </p>
              </div>

              <edit-resource-button
                resource-label="Address"
                resource-name="addresses"
                resource-id-field="addressid"
                :resource="address"
                :filter="{ where: { personid: personId } }"
                :create-new="false"
                @save="refreshResources()"
                @delete="refreshResources()"
                :disabled="!currentUserCan('editAddresses')"
              >
                <template slot-scope="editProps">
                  <address-form :address="editProps.item"></address-form>
                </template>
              </edit-resource-button>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-tab-item>

        <!-- <v-tab>Historical </v-tab>
        <v-tab-item>Old Addresses:</v-tab-item> -->
      </v-tabs>
    </v-card-text>
  </v-card>
</template>

<script>
// import moment from "moment";
// import deleteItemButton from "@/components/lib/delete-item-button";
import { mapGetters } from "vuex";
import addressForm from "./form";
import workAddressList from "./work/list";

export default {
  name: "AddressList",
  data() {
    return {
      person: {},
      practitioner: {},
      apc: [],
      qualifications: [],
      addresses: [],
      errors: [],
      activeTab: null,
      showTabs: false
    };
  },
  computed: {
    ...mapGetters({ lookup: "lookup", loading: "isLoading" }),
    activeAddresses() {
      return this.addresses.filter(a => a.status);
    }
  },
  methods: {
    async refreshResources() {
      try {
        const person = await this.$store.dispatch("load", this.personId);
        this.addresses = person.addresses;
      } catch (e) {
        console.log(e);
      }
    },
    async loadResources() {
      if (!this.personId) {
        this.errors.push("personid not defined");
        return;
      }
      // this.loading = true;
      try {
        const person = await this.$store.dispatch("getById", this.personId);
        if (person && person.addresses) {
          this.addresses = person.addresses || [];
        }
      } catch (e) {
        this.handleError(e);
      } finally {
        // this.loading = false
      }
    },
    handleError(e) {
      this.errors.push(e.message);
    }
  },
  props: {
    personId: String
  },
  watch: {
    personId: {
      handler: "loadResources",
      immediate: true
    }
  },
  filters: {
    currency(amount) {
      return "$" + amount;
    }
  },
  components: {
    // "delete-item-button": deleteItemButton,
    "address-form": addressForm,
    workAddressList
  }
};
</script>

<style scoped>
.address {
  margin-left: 2em;
  margin-bottom: 2em;
}
.address p {
  margin: 0;
}
.nl2br {
  white-space: pre;
}
</style>
